// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { Divider } from 'primereact/divider';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import "../assets/functionalComponents/ScrollPanelDemo.css"

export const WeatherModuleComponents = (props) => {

    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [startTimeScope, setStartTimeScope] = useState("");
    const [endTimeScope, setEndTimeScope] = useState("");
    const [limit, setLimit] = useState("");
    const [interval, setInterval] = useState(10);
    const [link, setLink] = useState({});
    const [startToPlay, setStartToPlay] = useState(null);
    const [showProgress, setShowProgress] = useState(null);

    const toast = useRef(null);

    useEffect(() => {
        if (props.Weather) {
            getValidInterval();
        }
    }, [props.Weather])

    // 取得可展示歷史雷達回波圖之起始終止時間
    const getValidInterval = () => {

        let weather = window.main.OView.getModule("weather");
        weather.proxy = "weather.ashx?";
        weather.authorization = "CWB-37D2C858-E377-4B2C-94C5-FA38AA2DB521";
    
        let timespan = weather.getRadarReflectivityHistoryValidTimeSpan();
    
        setStartTime(new Date(timespan[1].getTime() - 60 * 60 * 1000 * 12));
        setEndTime(new Date(timespan[1].getTime()));

        setStartTimeScope(new Date(timespan[0].getTime()));
        setEndTimeScope(new Date(timespan[1].getTime()));

    }

    // 透過起始終止時間自動計算雷達回波limit數值
    useEffect(() =>{
                                                       // ms=>s  s=>min  min=> hr
        let offset =  Math.floor((endTime - startTime) / (1000  *  60   *   60   ) * 6); 
        setLimit(offset);

    }, [startTime, endTime])

    useEffect(() =>{
        if(startToPlay === null) return;
        else if (startToPlay === true) {
            startToShow();
            // 載入進度條，避免使用者因資料載入過久而以為的網頁崩潰
            setShowProgress(true);
        } else {
            cancelToShow();
        }
    }, [startToPlay])

    const startToShow = () => {

        let historylayer = null;
        let weather = window.main.OView.getModule("weather");
        let timeline = window.main.OView.getWidgetByType(window.ov.Widget.Timeline);
        let timelinePlayer = window.main.OView.getWidgetByType(window.ov.Widget.TimelinePlayer);
        
        weather.removeAllLayer();

        toast.current.show({ severity: 'info', summary: '執行資訊', detail: '雷達歷史回波圖載入中，請稍後!', sticky: true});

        if (timeline) {
            timeline[0].removeLink(link);
            timelinePlayer[0].stop();
        }

        weather.addRadarReflectivityHistoryLayer({
            layername: "weather",
            timeFrom: new Date(startTime),
            timeTo: new Date(endTime),
            limit: limit,
            interval: interval
        },
        function (rtn) {
            toast.current.clear();
            toast.current.show({ severity: 'success', summary: '執行資訊', detail: '雷達歷史回波圖完成載入!'});
            setShowProgress(false);
            historylayer = rtn;
            addLayerToTimeline(historylayer);
        })
    }

    // 雷達回波載入後將其綁訂時間軸
    const addLayerToTimeline = (layer) => {

        let timeline = window.main.OView.getWidgetByType(window.ov.Widget.Timeline);
        let timelinePlayer = window.main.OView.getWidgetByType(window.ov.Widget.TimelinePlayer);

        timeline[0].updateParameter({ startTime: startTime, stopTime: endTime });

        timeline[0].toStart();
        timelinePlayer[0].play();

        timeline[0].addLink(layer);
        setLink(layer);
    }

    const cancelToShow = () => {
        let weather = window.main.OView.getModule("weather");
        let timeline = window.main.OView.getWidgetByType(window.ov.Widget.Timeline);
        let timelinePlayer = window.main.OView.getWidgetByType(window.ov.Widget.TimelinePlayer);

        weather.removeAllLayer();
        timeline[0].removeLink(link);
        timeline[0].toStart();
        timelinePlayer[0].stop();
    }

    return (
        <div>
        <Toast ref={toast} />
            <Dialog header="雷達歷史回波圖" visible={props.Weather} modal={false} keepInViewport={false} onHide={() => props.onHide('Weather')}>
                <Card>
                    <p className="m-0" style={{lineHeight: '1.5'}}>可展示時間範圍</p>
                    <Divider />
                    <p className="m-3" style={{lineHeight: '1.5'}}>起始時間：{startTimeScope.toString()}</p>
                    <p className="m-3" style={{lineHeight: '1.5'}}>終止時間：{endTimeScope.toString()}</p>
                </Card>
                <br></br>
                <Card>
                    <p className="m-0" style={{lineHeight: '1.5'}}>顯示資料設定</p>
                    <Divider />
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">開始時間：</label>
                        <div className="col-12 md:col-8">
                            <Calendar id="startTimeCalendar" value={startTime} onChange={(e) => setStartTime(e.value)} showTime showSeconds showButtonBar style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label class="col-12 mb-4 md:col-4 md:mb-0">結束時間：</label>
                        <div className="col-12 md:col-8">
                            <Calendar id="endTimeCalendar" value={endTime} onChange={(e) => setEndTime(e.value)} minDate={startTime} showTime showSeconds showButtonBar style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-4 md:col-4 md:mb-0">資料筆數上限 :</label>
                        <div className="col-12 md:col-8">
                            <InputText value={limit} onChange={(e) => setLimit(e.target.value)} style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div className="field grid">
                        <label className="col-12 mb-4 md:col-4 md:mb-0">資料間隔(分鐘) :</label>
                        <div className="col-12 md:col-8">
                            <InputText value={interval} onChange={(e) => setInterval(e.target.value)} style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div>
                        {
                            showProgress === true || null ? 
                                <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar> : null
                        }
                    </div>
                    <Divider />
                    <div className="field grid">
                        <div className="col-12 md:col-6">
                            <Button label="更新/回復為有效區間" icon="pi pi-refresh" className="p-button-raised p-button-info " onClick={() => { getValidInterval() }} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 md:col-6">
                            {
                                startToPlay === true || null ? 
                                    <Button label="結束演示" icon="pi pi-times" className="p-button-raised p-button-danger " onClick={() => { setStartToPlay(false) }} style={{ width: "100%" }} /> : 
                                    <Button label="開始演示" icon="pi pi-caret-right" className="p-button-raised p-button-success " onClick={() => { setStartToPlay(true) }} style={{ width: "100%" }} />   
                            }
                        </div>
                    </div>
                </Card>
            </Dialog>
        </div>
    )
}